<template>
  <v-container fluid>
    <!-- DELETE CONFIRM -->
    <v-dialog
      v-model="showDeleteConfirm"
      persistent
      max-width="400"> 
      <v-card>
        <v-flex class="text-xs-center">
          <h3>{{ deleteMessage }}</h3> 
        </v-flex>
        <v-card-text class="text-xs-center">
          <h4>{{ agencyNameD }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex>
            <v-btn
              v-show="showCancelDelete"
              color="red darken-1"
              outline
              @click.native="showDeleteConfirm = false">
              <v-icon left>close</v-icon>
              Cancelar
            </v-btn>
            <v-btn 
              color="red darken-1"                    
              @click="deleteAgency"
              :loading="$loading.isLoading(`Deleting agency ${agencyIdD}`)">
              <v-icon left>delete_forever</v-icon>
              Eliminar
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout>
      <v-flex
        class="section-1 general-bg"
        column
        pb-4>
        <!-- AGENCIES -->
        <v-flex         
          px-4>
          <h3 class="text-xs-center pt-2">Agencias</h3>
          <h5 class="pt-3">Crear</h5>
          <p>
          Escriba el nombre de la Agencia que quiere crear.
          </p>
          <v-flex class="text-xs-right" d-flex align-center>
            <p class="message-1 pr-2">
              Sí la agencia nueva a crear esta vinculada con otra Agencia, por favor indiquelo seleccionadola antes de crearla en el Listado de Agencias.
            </p>
            <v-icon class="icon-arrow" size="100" color="teal accent-3">arrow_right</v-icon>
          </v-flex>
        </v-flex>
        <!-- FORM CRUD AGENCIES -->
        <v-flex px-4>
          <v-form ref="form1" v-model="valid" lazy-validation @submit.prevent>
            <v-text-field
              :disabled="role.length === 1"
              v-model="agencyName"
              label="Nombre Agencia"
              color="white"
              required
              :rules="agencyNameRules">
            </v-text-field>
          </v-form>
          <v-flex class="text-xs-right">
            <v-btn
              :disabled="role.length === 1"
              class="mb-3"
              color="teal accent-3 grey--text text--darken-3"
              @click="createAgency"
              :loading="$loading.isLoading('Creating agency')">
              <v-icon left>add</v-icon>
              Crear Agencia
            </v-btn>
          </v-flex>
        </v-flex>        
      </v-flex>
      <!-- AGENCIES TREE -->
      <v-flex
        class="section-2 general-bg"
        column
        pb-4
        ml-2>
        <v-flex pl-4 pt-3>
          <h3>Listado de Agencias</h3>
          <p class="pr-3">Seleccione la agencia a la cual debe pertenecer la NUEVA agencia a CREAR.</p>
        </v-flex>
        <!-- LOADING AGENCIES TREE -->
        <v-progress-linear indeterminate v-if="$loading.isLoading('fetchingAgenciesTree')"/>
        <!-- AGENCIES TREE -->
        <v-treeview
          class="px-4"          
          v-if="!$loading.isLoading('fetchingAgenciesTree')"
          :active.sync="active"
          :items="agenciesTree"
          item-key="id"
          activatable
          active-class="grey darken-1 teal--text text--accent-3" >
        </v-treeview>
      </v-flex>     
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as types from '../store/mutations-types'
import { agenciesMixin } from '../mixins/agenciesMixin.js'

export default {
  name: 'agencies-crud',
  mixins: [agenciesMixin],
  data() {
    return {
      editActive: false,
      // match: false,
      // active: [],
      // agencySelectedIn: null,
      agencyName: '',
      valid: true,
      // agencies: [],
      stateE: 'Editar',
      textControl: true,
      agencyTemp: {},
      showDeleteConfirm: false,
      showCancelDelete: true,
      deleteMessage: 'Desea Eliminar la Agencia?',
      agencyNameD: '',
      agencyIdD: null
    }
  },
  computed: {
    ...mapGetters(['agenciesTree', 'agencies', 'agencyNameRules']),
    ...mapGetters({role: 'auth/role'}),
    agencySelected() {
      if (this.active.length === 0) return null
      this.recursiveSearch(this.agenciesTree)

      // console.log('AGENCY SELECTED: ', this.agencySelectedIn)

      this.agencyTemp.name = this.agencySelectedIn.name
      this.agencyTemp.id = this.agencySelectedIn.id

      this.match = false

      return this.agencySelectedIn
    }
  },
  methods: {
    ...mapActions([
      'fetchAgenciesTreeAction',
      'createAgencyAction',
      'updateAgencyAction',
      'deleteAgencyAction'
    ]),
    async createAgency() {
      // console.log('New Agency')
      let response
      if (this.$refs.form1.validate()) {
        try {
          const payload = {
            name: this.agencyName,
            id: this.active[0] ? this.active[0] : ''
          }
          // console.log('PAYLOAD: ', payload)
          response = await this.createAgencyAction(payload)
        } finally {
          this.$refs.form1.reset()
          // this.fetchAgencies()
          this.fetchAgenciesTree()
          // console.log('CREATED', response)
        }
      }
    },
    async editAgency(agency) {
      this.editActive = !this.editActive

      if (this.agencyTemp.name !== agency.name) {
        await this.updateAgencyAction(
          {
            id: this.agencyTemp.id,
            name: this.agencyTemp.name
          }
        )
        this.fetchAgenciesTree()
      }
    },
    async fetchAgenciesTree() {
      const {data: agenciesTree} = await this.fetchAgenciesTreeAction()
    },
    deleteAgencyPre(agency) {
      this.agencyIdD = this.agencySelectedIn.id
      this.agencyNameD = this.agencySelectedIn.name
      this.showDeleteConfirm = true
    },
    async deleteAgency() {
      // console.log('DELETE AGENCY', id)
      this.showCancelDelete = false
      this.deleteMessage = 'Eliminando Agencia'
      await this.deleteAgencyAction(this.agencyIdD)

      this.showDeleteConfirm = false
      this.deleteMessage = 'Desea Eliminar la Agencia?'
      this.agencyIdD = null
      this.agencyNameD = ''
      this.showCancelDelete = true
      this.fetchAgenciesTree()
      // this.fetchAgencies()
    }
  },
  created() {
    this.agencySelectedIn = null
    this.fetchAgenciesTree()
    // this.fetchAgencies()
  }
}
</script>


<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500

h4
  font-size 46px
  font-weight 500
  color grey  

h5
  font-size 24px
  font-weight 500

.icon-arrow
  max-width 50px
  min-width 50px
  margin-bottom 10px


.message-1
  border-right 3px solid
  border-color #1DE9B6

.message-2
  border-left 3px solid
  border-color #FFB300

.general-bg
  background-color #424242
  border-radius 3px  

.section-1
  min-width 420px
  max-width 420px

.section-2
  min-width 500px
  max-width 500px

.line-1
  border-top solid grey 1px

.header-agency
  height 30px
  
.mini-text
  font-size 11px

.info-agency
  background-color #212121
  height 80px
  margin-bottom 1px 

</style>




// WEBPACK FOOTER //
// src/components/AgenciesCRUD.vue